import React from 'react';

import { fg } from '@townsquare/stat-sig/gate';

import Network5xxError from './ErrorComponents/Network5xxError';
import { ErrorContainer as StyledErrorContainer } from './styles';
import { ErrorContainer as CompiledErrorContainer } from './styles.compiled';

const ErrorContainer = fg('townsquare_compiled_css_migration_goals')
	? CompiledErrorContainer
	: StyledErrorContainer;

export const FullPageError = (props: { testId?: string }): React.JSX.Element => (
	<ErrorContainer isFullPage data-testid={props.testId}>
		<Network5xxError />
	</ErrorContainer>
);
